import type { MessageDescriptor } from 'react-intl';
import type { ProfileImageTool } from '../profileRoute';
import { profileToolMessages as t } from './profileToolMessages';

/** The hints and the guide note of each image tool (design b1–b4). */
export const TOOL_COPY: Readonly<
  Record<
    ProfileImageTool,
    { pictureHint: MessageDescriptor; positionHint: MessageDescriptor; guideNote: MessageDescriptor }
  >
> = {
  spotifyHeader: { pictureHint: t.headerPictureHint, positionHint: t.headerPositionHint, guideNote: t.headerGuideNote },
  banners: { pictureHint: t.bannersPictureHint, positionHint: t.bannersPositionHint, guideNote: t.bannersGuideNote },
  spotifyAvatar: { pictureHint: t.avatarPictureHint, positionHint: t.avatarPositionHint, guideNote: t.avatarGuideNote },
  pressPhoto: { pictureHint: t.pressPictureHint, positionHint: t.pressPositionHint, guideNote: t.pressGuideNote },
};

/** The sentence of a missing id ("Pick a photo first."). */
export const BLOCKER_TEXT: Readonly<Record<'release' | 'photo' | 'picture', MessageDescriptor>> = {
  release: t.needsRelease,
  photo: t.needsPhoto,
  picture: t.needsPicture,
};
